import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import UploadPage from "@/pages/UploadPage";
import ReportViewPage from "@/pages/ReportViewPage";
import ReportsListPage from "@/pages/ReportsListPage";
import OptimizationUploadPage from "@/pages/OptimizationUploadPage";
import OptimizationReportsListPage from "@/pages/OptimizationReportsListPage";
import OptimizationReportViewPage from "@/pages/OptimizationReportViewPage";
import ConsumptionUploadPage from "@/pages/ConsumptionUploadPage";
import ConsumptionReportsListPage from "@/pages/ConsumptionReportsListPage";
import ConsumptionReportViewPage from "@/pages/ConsumptionReportViewPage";
import MultisitesReportViewPage from "@/pages/MultisitesReportViewPage";
import MultiClientDashboardPage from "@/pages/MultiClientDashboardPage";
import UsersManagementPage from "@/pages/UsersManagementPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/upload" element={
              <ProtectedRoute>
                <UploadPage />
              </ProtectedRoute>
            } />
            <Route path="/reports" element={
              <ProtectedRoute>
                <ReportsListPage />
              </ProtectedRoute>
            } />
            <Route path="/report/:id" element={<ReportViewPage />} />
            
            {/* Optimization Routes */}
            <Route path="/optimization/upload" element={
              <ProtectedRoute>
                <OptimizationUploadPage />
              </ProtectedRoute>
            } />
            <Route path="/optimization/reports" element={
              <ProtectedRoute>
                <OptimizationReportsListPage />
              </ProtectedRoute>
            } />
            <Route path="/optimization/report/:id" element={<OptimizationReportViewPage />} />
            
            {/* Consumption Routes */}
            <Route path="/consumption/upload" element={
              <ProtectedRoute>
                <ConsumptionUploadPage />
              </ProtectedRoute>
            } />
            <Route path="/consumption/reports" element={
              <ProtectedRoute>
                <ConsumptionReportsListPage />
              </ProtectedRoute>
            } />
            <Route path="/consumption/report/:id" element={<ConsumptionReportViewPage />} />
            <Route path="/consumption/multisites/:id" element={<MultisitesReportViewPage />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <MultiClientDashboardPage />
              </ProtectedRoute>
            } />
            
            {/* Admin Routes */}
            <Route path="/admin/users" element={
              <ProtectedRoute>
                <UsersManagementPage />
              </ProtectedRoute>
            } />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
